/*
 *  (c) 2015 - 2022 ENISCO by FORCAM GmbH
 */

import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'

const useRegisteredUserSettings = () => {
  const registeredUserSettings = useSelector(
    (state: AppRootState) => state.app.registeredUserSettings
  )

  return [registeredUserSettings]
}

export default useRegisteredUserSettings
